import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Button } from '@cp/ds/src/components/button';
import { Typography } from '@cp/ds/src/components/typography';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { ArrowRightIcon } from '@cp/ds/src/icons';
import { styled } from '@cp/ds/src/theme/styled';
import { Roundel } from '@cp/ds/src/components/roundel';
import { SvgIconComponent } from '@cp/ds/src/components/svgIcon';
import { StepFooter } from '../stepFooter';
import flowDone from '../assets/finish-x3.png';
import { StepContainer } from '../stepContainer';
import { StepProps } from './model';

const DoneImage = styled(Box)(({ theme }) => ({
  margin: 'auto',
  width: '281px',
  height: '322px',
  background: `url(${flowDone}) center center/100% no-repeat`,
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    width: '400px',
    height: '430px',
  },
}));

export interface BlockResultProps extends StepProps {
  icon: SvgIconComponent;
}

export const FlowResult: React.FC<BlockResultProps> = ({ onSubmit, icon }) => {
  const isMobile = useIsMobile();
  const Icon = icon;
  return (
    <>
      <StepContainer sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Roundel size="small" sx={{ display: { xs: 'initial', [MOBILE_BREAKPOINT_THRESHOLD]: 'none' } }}>
          <Icon />
        </Roundel>
        <Typography sx={{ textAlign: 'center', mt: 3, mb: 5 }} variant={isMobile ? 'h2' : 'h1'}>
          Поздравляем! Вы прошли обучение. Если Вы загрузили фотографию и заполнили все данные в анкете, мы опубликуем ее в течение суток в
          рабочее время.
        </Typography>
        <DoneImage />
      </StepContainer>
      <StepFooter>
        <Button
          iconRight={isMobile ? undefined : <ArrowRightIcon />}
          onClick={() => onSubmit()}
          sx={{ width: { xs: 1, [MOBILE_BREAKPOINT_THRESHOLD]: 'auto' } }}
        >
          Разместить анкету
        </Button>
      </StepFooter>
    </>
  );
};
